export default __webpack_public_path__ + "static/media/fb-bl-icon.03c741c4.svg";